import { ActivityEventProcessType } from '@warebee/shared/import-converter';

export const managementKpis /*: WarehouseKPI[] */ = [
  {
    id: 'management_placeholder',
    processType: ActivityEventProcessType.MANAGEMENT,
    category: 'process',
    title: 'Management Activity',
    description: 'No KPI defined yet for Management process.',
    unit: '',
    formula: '',
    tags: ['management'],
    benchmark: undefined,
    trendWindow: undefined,
    drillDimensions: [],
    alertTopic: '',
  },
  {
    id: 'management_yard_placeholder',
    processType: ActivityEventProcessType.MANAGEMENT_YARD,
    category: 'process',
    title: 'Yard Management Activity',
    description: 'No KPI defined yet for Yard Management process.',
    unit: '',
    formula: '',
    tags: ['management_yard'],
    benchmark: undefined,
    trendWindow: undefined,
    drillDimensions: [],
    alertTopic: '',
  },
  {
    id: 'management_data_placeholder',
    processType: ActivityEventProcessType.MANAGEMENT_DATA,
    category: 'process',
    title: 'Data Management Activity',
    description: 'No KPI defined yet for Data Management process.',
    unit: '',
    formula: '',
    tags: ['management_data'],
    benchmark: undefined,
    trendWindow: undefined,
    drillDimensions: [],
    alertTopic: '',
  },
  {
    id: 'management_wms_placeholder',
    processType: ActivityEventProcessType.MANAGEMENT_WMS,
    category: 'process',
    title: 'WMS Management Activity',
    description: 'No KPI defined yet for WMS Management process.',
    unit: '',
    formula: '',
    tags: ['management_wms'],
    benchmark: undefined,
    trendWindow: undefined,
    drillDimensions: [],
    alertTopic: '',
  },
];

export default managementKpis;
